<template>
  <div :class="['sender-badge', senderClass]">
    {{ senderText }}
  </div>
</template>

<script>
export default {
  name: "Sender",
  props: {
    senderTR: {
      type: String,
      default: "",
    },
  },
  computed: {
    senderClass() {
      return this.senderTR === "n11 Depom" ? "n11" : "store";
    },
    senderText() {
      return this.senderTR
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";

.sender-badge {
  display: inline-flex;
  height: 24px;
  padding: 2px 6px;
  align-items: center;
  gap: 4px;
  border-radius: 4px;
  font-size: 11px;
  font-style: normal;
  font-weight: 600;
  line-height: 14px;
  margin: 0 12px !important;

  &.n11 {
    background: $colorM05;
    color: $colorM50;
    border: 0.5px solid $colorM50;
    padding: 2px 12px;
  }

  &.store {
    background: $colorY10;
    color: $colorN80;
    border: 0.5px solid $colorY10;
  }
}
</style>
